//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.MoveBuilder.js";
let d=[[],[[[],"GetDepartureType",{R_:{motionDirection:''}},0,0],[["motionDirection"],"SetDepartureType",{},1,0],[[],"GetApproachType",{R_:{motionDirection:''}},0,0],[["motionDirection"],"SetApproachType",{},1,0],[[],"GetClearanceDistance",{R_:{clearanceDistance:''}},0,0],[["clearanceDistance"],"SetClearanceDistance",{},1,0],[[],"GetTransferType",{R_:{transferType:''}},0,0],[["transferType"],"SetTransferType",{},1,0]],[]];
SPLM.CAM.MachineClearanceMoveBuilder = class extends SPLM.CAM.MoveBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.MachineClearanceMoveBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.MachineClearanceMoveBuilder.MotionDirection = Object.freeze({
    "ToolAxis" : "ToolAxis", "ShortestDistance" : "ShortestDistance"});

SPLM.CAM.MachineClearanceMoveBuilder.TransferType = Object.freeze({
    "MachineClearance" : "MachineClearance", "TangentPlane" : "TangentPlane"});

export default SPLM;